import React, {useEffect} from "react";
import { Grid, Typography, Box, Button } from "@mui/material/";
import { styled } from "@mui/material/styles";
import DialogVideo from "./DialogVideo";
import "./Video.css";

const SendButtonSmall = styled(Button)(({ theme }) => ({
  color: theme.palette.getContrastText("#000"),
  backgroundColor: "#1a5080",
  "&:hover": {
    backgroundColor: "#85a537",
  },
  width: "140px",
  height: "50px",
  fontWeight: "bold",
  fontSize: "14px",
  borderRadius: "20px",
  lineHeight: 1.2,
  boxShadow:
    "0 13px 27px -5px rgba(50, 50, 93, 0.25),    0 8px 16px -8px rgba(0, 0, 0, 0.3)",
}));

function Video() {
  const [open, setOpen] = React.useState(false);

  useEffect(() => {
    let videoOn = null;
    const videoOnStorage = localStorage.getItem("videoOnStorage");
    if (videoOnStorage === null) {
      videoOn = true;
      localStorage.setItem("videoOnStorage", videoOn);
      setOpen(videoOn)
    } else {
      setOpen(false)
      videoOn = videoOnStorage;
    }

  }, []);

  return (
    <>
      <div className="video">
        <Grid container spacing={2}>
          <Grid item xs={12} md={8}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              style={{ width: "100%", height: "100%" }}
            >
              <Typography
                variant="subtitule1"
                align="center"
                className="textVideo"
              >
                Aquí puedes ver el vídeo nuevamente.
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              style={{ width: "100%", height: "100%" }}
            >
              <SendButtonSmall
                variant="contained"
                onClick={() => setOpen(true)}
              >
                VER VÍDEO
              </SendButtonSmall>
            </Box>
          </Grid>
        </Grid>
      </div>
      {open ? <DialogVideo open={open} setOpen={setOpen} /> : ""}
    </>
  );
}

export default Video;
